import { render, staticRenderFns } from "./ShoppingCartCount.vue?vue&type=template&id=b6ceb7b6"
import script from "./ShoppingCartCount.vue?vue&type=script&lang=js"
export * from "./ShoppingCartCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports